import { RegionEnum } from "@edp-enums/region.enum";

/**
 * Elements and Components that should not be rendered by regions
 */
export const regionElementsHidden = {
    "pt.edp.edponline.contract.managedby": [RegionEnum.ES],
    "pt.edp.edponline.contract.welcome": [RegionEnum.PT],
    "pt.edp.edponline.contract.contact.info": [RegionEnum.ES],
    "pt.edp.edponline.contract.es": [RegionEnum.PT],
    "pt.edp.edponline.contract.pt": [RegionEnum.ES],
    "pt.edp.edponline.contract.consumption.local.pt": [RegionEnum.ES],
    "pt.edp.edponline.contract.consumption.local.es": [RegionEnum.PT],
    "pt.edp.edponline.header.contract.offer": [RegionEnum.ES],
    "pt.edp.edponline.header.contract.pack": [RegionEnum.ES],
    "pt.edp.edponline.contract.profile.edit": [RegionEnum.ES],
    "pt.edp.edponline.profile.languages": [RegionEnum.ES],
    "pt.edp.edponline.contract.profile.user.contracts.pt": [RegionEnum.ES],
    "pt.edp.edponline.contract.profile.user.contracts.es": [RegionEnum.PT],
    "pt.edp.edponline.contract.profile.actions.pt": [RegionEnum.ES],
    "pt.edp.edponline.footer.download.app": [RegionEnum.ES],
    "pt.edp.edponline.footer.nav.pt":  [RegionEnum.ES],
    "pt.edp.edponline.footer.nav.es":  [RegionEnum.PT],
    "pt.edp.edponline.footer.nav.social.media.pt":  [RegionEnum.ES],
    "pt.edp.edponline.footer.nav.social.media.es":  [RegionEnum.PT],
    "pt.edp.edponline.contract.header.store": [RegionEnum.ES],
    "pt.edp.edponline.contract.header.notifications": [RegionEnum.ES],
    "pt.edp.edponline.contract.profile.user.complete.pt": [RegionEnum.ES],
};

export const regionComponentsHidden = {
    "pt.edp.edponline.chat": [RegionEnum.ES],
};
